import Tuple, { supportsWeak } from "./Tuple.js";
// @ts-expect-error Symbol.isRecord is usually not assignable
if (!Symbol.isRecord)
    Symbol.isRecord = Symbol("isRecord");
const tuplesByRecord = supportsWeak
    ? new WeakMap()
    : new Map();
const recordsByTuple = supportsWeak
    ? new WeakMap()
    : new Map();
export const symbolKeyError = new TypeError("A Symbol cannot be used as a property key in a Record.");
export const nonRecordError = new TypeError("Record.entries received a non-record.");
function Record(obj) {
    if (Object.getOwnPropertySymbols(obj).length > 0)
        throw symbolKeyError;
    return Record.fromEntries(Object.entries(obj));
}
Record.entries = (record) => {
    const tuple = tuplesByRecord.get(record);
    if (!tuple)
        throw nonRecordError;
    return tuple;
};
Record.fromEntries = (entries) => {
    // @ts-expect-error `entries` is not necessarily a tuple
    if (recordsByTuple.has(entries))
        return recordsByTuple.get(entries);
    const tuple = Tuple.from([...entries]
        .sort(([a], [b]) => a.localeCompare(b))
        .map((entry) => {
        if (typeof entry[0] === "symbol")
            throw symbolKeyError;
        return Tuple.from(entry);
    }));
    if (!recordsByTuple.has(tuple)) {
        const record = Object.freeze(Object.assign(Object.fromEntries(tuple), {
            [Symbol.isRecord]: true,
        }));
        recordsByTuple.set(tuple, record);
        tuplesByRecord.set(record, tuple);
    }
    return recordsByTuple.get(tuple);
};
Record.isRecord = (maybeRecord) => tuplesByRecord.has(maybeRecord);
export default Record;
